import { request } from "../network/request";
const db = "dn0";

export function pstjList(query) {
    return request({
        url: "pmp/xmReview/pstjList",
        method: "post",
        params:
            query

    });
}

export function pstjExport(query) {
    return request({
        url: "pmp/xmReview/pstjExport",
        method: "post",
        params:
            query
    });
}

export function redirectZx(params) {
    return request({
        url: "pmp/xmReview/redirectZx",
        method: "get",
        params,
    });
}

export function getAreaDirectorList(params) {
    return request({
        url: "system/getAreaDirectorList",
        method: "get",
        params,
    });
}




